<div class="edit-page-root-container usergroup-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="50" appCodeInput
                                        [readonly]="userGroupInfo.id!==undefined && userGroupInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                        10.</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right"> <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Name should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error>
                                </mat-form-field></div>

                        </div>
                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                            <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length is
                                200.</mat-error>
                        </mat-form-field>


                        <div formGroupName="user_type" *ngIf="!isShopUser">
                            <div style="display: flex; gap: 16px; align-items: center;">
                                <mat-checkbox formControlName="hq">HQ</mat-checkbox>
                                <mat-checkbox formControlName="shop">Shop</mat-checkbox>
                                <mat-checkbox formControlName="areaManager">Area Manager</mat-checkbox>
                            </div>
                            <mat-error
                                *ngIf="editForm.get('user_type')?.hasError('required') && editForm.get('user_type')?.touched"
                                style="font-size: 75%; margin-top: 4px; padding-left: 5px;">
                                Please select at least one User Type.
                            </mat-error>
                        </div>
                        <!-- <div>Type Value: {{ editForm.get('user_type')?.value }}</div> -->
                        <div formGroupName="menu" *ngIf="showMenuCheckboxes && !isShopUser" style="margin-top: 16px;">
                            <table style="padding-top: 10px;">
                                <tr>
                                    <td><mat-checkbox
                                            formControlName="is_dashboard_page_visible">Dashboard</mat-checkbox></td>
                                    <td><mat-checkbox formControlName="is_manager_page_visible">Manager</mat-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td><mat-checkbox formControlName="is_people_page_visible">People</mat-checkbox>
                                    </td>
                                    <td><mat-checkbox formControlName="is_user_page_visible">User</mat-checkbox></td>
                                </tr>
                                <tr>
                                    <td><mat-checkbox
                                            formControlName="is_utilities_page_visible">Utilities</mat-checkbox>
                                    </td>
                                    <td><mat-checkbox formControlName="is_userdefined_page1_visible">Sushi Manager
                                            Extra</mat-checkbox></td>
                                </tr>

                                <tr>
                                    <td><mat-checkbox formControlName="is_reports_page_visible">Reports</mat-checkbox>
                                    </td>
                                    <td><mat-checkbox formControlName="is_userdefined_page2_visible">Assistant
                                            Manager</mat-checkbox></td>
                                </tr>
                                <tr>
                                    <td><mat-checkbox formControlName="is_settings_page_visible">Settings</mat-checkbox>
                                    </td>
                                    <td><mat-checkbox formControlName="is_userdefined_page3_visible">Trainee
                                            Manager</mat-checkbox></td>
                                </tr>
                                <tr>
                                    <td><mat-checkbox formControlName="is_attendance_page_visible">Attendance for
                                            approval</mat-checkbox></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>







            </form>
        </div>
    </div>
</div>